module.exports = __webpack_public_path__ + "img/tappir-logo.32575916.svg";